import React, { useState } from 'react';

function ErrorTab() {

  return (
    <div>
      <p>Erreur : composant non connecté</p>
    </div>
  );
}

export default ErrorTab;
